module.exports = __webpack_public_path__ + "img/tea_1.6792bb53.png";